import PageLayout from '../../common/components/PageLayout/PageLayout'
import './Notebook.css'
import {
  VerticalTimeline,
  VerticalTimelineElement
} from 'react-vertical-timeline-component'
import { data } from './data'
import Title from '../../common/components/Title/Title'
import React from 'react'
import 'react-vertical-timeline-component/style.min.css'

function Notebook () {
  return (
    <PageLayout title="Notebook">
      <p>
        In this page, you will find the timeline of our project, Blood Cell
        Barber Shop. Our journey began by the recruitment of our new members in
        December of last year. As soon as our new members were integrated into
        the team in January, we began to brainstorm ideas for a new project. We
        then began to do some research in the literature to define our objective
        for this year. In spring, we contacted experts in the field to further
        define our objectives based on the gaps of knowledge in this field. We
        also began our fundraising and workings on our education and
        communication events for this year. Our wet lab was mainly done over the
        summer, as well as the dry lab.
      </p>
      <VerticalTimeline lineColor="#d5d9db">
        {data.map((elem, elemIndex) => (
          <React.Fragment key={elemIndex}>
            <Title title={elem.month} />
            {elem.events.map((event, eventIndex) => (
              <VerticalTimelineElement
                key={eventIndex}
                position="right"
                className="vertical-timeline-element--work"
                contentStyle={{
                  background: '#e6eaec',
                  color: 'black',
                  borderTop: `4px solid #${
                    elemIndex % 2 === 0 ? 'b62032' : '18417c'
                  }`
                }}
                contentArrowStyle={{
                  borderRight: '7px solid  #f2f7fa'
                }}
                iconStyle={{
                  background: `#${elemIndex % 2 === 0 ? '9d1b2a' : '18417c'}`,
                  color: '#d5d9db'
                }}
                icon={<img srcSet={event.icon} />}
                date={event.date}
              >
                <p>{event.content}</p>
              </VerticalTimelineElement>
            ))}
          </React.Fragment>
        ))}
      </VerticalTimeline>
    </PageLayout>
  )
}

export default Notebook
